<div class="specialities">
    <div class="title">
        <div class="tit">
            <h3>BLOG BEJEGYZÉSEK</h3>
            <div class="add-icon">
                <mat-icon routerLink="/addblog">add_circle</mat-icon>
            </div>
        </div>
    </div>

    <div class="add-new-speciality">
        <div class="search-bar">
            <div class="search-tool">
                <input [(ngModel)]="listFilter" type="search" placeholder="Blog címe" />
                <div class="icon">
                    <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search"></mat-icon>
                </div>
            </div>
        </div>
    </div>
    <div class="mat-radio-container">
        <mat-radio-group [(ngModel)]="selectedFilterType" (change)="onFilterChange($event.value)">
            <mat-radio-button value="ALL">Összes</mat-radio-button>
            <mat-radio-button value="NEWS">Hírek</mat-radio-button>
            <mat-radio-button value="SMARTY">Kisokos</mat-radio-button>
        </mat-radio-group>

    </div>
    <div class="speciality-container">
        <div class="speciality-c">
            <div *ngFor="let blogWithActive of filteredBlogs; let i = index" class="speciality">
                <div class="pro">
                    <div [ngStyle]="
                            i % 2 === 0 ? { background: 'white', border: '1px solid #ccc' } : { background: '#efeff5', border: 'black' }
                        " class="name">
                        <div [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }"
                            class="button" routerLink="/blog/{{ blogWithActive.blog?.routerLink }}">
                            {{ blogWithActive.blog?.title }}
                        </div>
                        <div class="form-not-required">
                            <div class="field-container">
                                <div class="field">
                                    <div *ngIf="blogWithActive.active">PUBLIKÁLT</div>
                                    <div [ngStyle]="{ color: 'red' }" *ngIf="!blogWithActive.active">NEM PUBLIKÁLT</div>
                                    <div class="data">
                                        <mat-checkbox (click)="onChangeActive(blogWithActive)"
                                            [ngModel]="blogWithActive.active" id="active" class="form-control"
                                            type="checkbox" required
                                            [ngStyle]="{ 'font-weight': 'bold' }"></mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <mat-icon (click)="openDeleteBlogPopup(blogWithActive.blog!)"
                            [ngStyle]="{ cursor: 'pointer' }">delete_forever</mat-icon>
                    </div>
                </div>
            </div>
        </div>
        <div [ngStyle]="{ 'margin-top': '8px' }" class="field-container">
            <div [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }" class="field">
                <div [ngStyle]="{ 'justify-content': 'center' }" class="data">
                    <button (click)="updateBlog()" [ngStyle]="{
                            background: '#eee',
                            border: '1px solid #0E8388',
                            'font-weight': 'bold',
                            width: '100%',
                            cursor: 'pointer'
                        }">
                        BLOG MÓDOSÍTÁSA
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
